module.exports = __webpack_public_path__ + "static/media/newgoal.2ec3c5aa.png";